<div id="faq_box" class="mt-3" *ngIf="faqFields && faqFields.length > 0" [ngClass]="classes">

  <div class="br-24 p-3 bg-white border box-shadow">
    <mat-accordion>
      <mat-expansion-panel hideToggle *ngFor="let FAQ of faqFields;let index = index; let isFirst = first" [expanded]="firstExpanded && isFirst" (click)="changeIcon(index)">

        <mat-expansion-panel-header class="py-0 px-3">
          <mat-panel-title class="text-primary lf-font d-flex align-items-center">
           <span class="material-icons text-black me-4"> {{ panelOpen === faqFields.indexOf(FAQ) ? 'remove' : 'add' }} </span>
            <span class="txt-blue-sky">{{ FAQ.key | translate }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="d-flex flex-row gap-16 align-items-center mb-2" *ngFor="let content of FAQ.content">
          <p [ngClass]="{'pt-2' : isMobile}" class="mediumGray" [innerHTML]="content['key'] | translate"></p>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </div>

</div>
